/**存放自定义指令 */
import { nextTick } from "vue";
//!!!!使用时,挂载的元素如果需要控制显示与否,需要使用v-if而非v-show
//判断元素是否过长，没有超出宽度，即子<父 则移除tooltip
export const compareWidth = (el) => {
  // nextTick 解决el-menu展开获取不到宽度的问题
  nextTick(() => {
    nextTick(() => {
      console.log(
        el.querySelector(".ellipse-text").offsetWidth,
        el.offsetWidth,
        el
      );
      if (
        el.querySelector(".ellipse-text") &&
        el.querySelector(".ellipse-text").offsetWidth <= el.offsetWidth
      ) {
        console.log("remove");
        if (el.querySelector(".el-tooltip__trigger")) {
          const copySpan = el.querySelector(".ellipse-text"); //获取 ellipse-text
          const copyTip = el.querySelector(".el-tooltip__trigger"); //获取 tooltip 元素
          el.removeChild(copyTip); //删除 tooltip 元素 // 创建一个 ellipse div 元素
          var ellipseElement = document.createElement("div");
          ellipseElement.classList.add("ellipse");
          el.appendChild(ellipseElement);
          ellipseElement.appendChild(copySpan); //添加 ellipse-text 元素
        }
      }
    });
  });
};
export default {
  install(app) {
    // 注册一个全局自定义指令 `showTip`
    app.directive("showTip", {
      // 只调用一次，指令第一次绑定到元素时调用。在这里可以进行一次性的初始化设置。
      created(el, binding) {
        // bind的时候无法获取到已经带有ajax数据的DOM元素，宽度为0
      },
      // 被绑定元素插入父节点时调用 (仅保证父节点存在，但不一定已被插入文档中)。
      mounted(el) {
        compareWidth(el); // 可以获取到ajax数据的DOM元素，即真实的宽度
      },
      // 所在组件的 VNode 更新时调用，但是可能发生在其子 VNode 更新之前。指令的值可能发生了改变，也可能没有。但是你可以通过比较更新前后的值来忽略不必要的模板更新
      updated(el) {
        compareWidth(el); // 可以获取到ajax数据的DOM元素，即真实的宽度
      },
    });
  },
};
